<template>
  <div>
    <el-table :data="projects" default-expand-all>
      <el-table-column label="时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | moment }}
        </template>
      </el-table-column>
      <el-table-column prop="pair" label="交易对"></el-table-column>
      <el-table-column prop="burstRate" label="爆仓风险率"></el-table-column>
      <el-table-column prop="interestRate" label="借贷利率"></el-table-column>
      <el-table-column
        prop="maxMultiple"
        label="最大杠杆倍数"
      ></el-table-column>
      <el-table-column prop="coinMinAmount" label="最小借币数量">
        <template slot-scope="scope">
          <div>
            {{ scope.row.coinMinAmount || 0 }}
            {{ scope.row.pair.split('_')[0] }}
          </div>
          <div>
            {{ scope.row.setMinAmount || 0 }} {{ scope.row.pair.split('_')[1] }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="setMinAmount"
        label="最小借币数量"
      ></el-table-column> -->
      <el-table-column
        prop="outRate"
        label="转出后最小风险率"
      ></el-table-column>
      <el-table-column prop="warnRate" label="报警风险率"></el-table-column>
      <el-table-column label="是否开启">
        <template slot-scope="scope">
          <span v-if="scope.row.open">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 0">全仓</span>
          <span v-else-if="scope.row.type === 1">逐仓</span>
          <span v-else-if="scope.row.type === 2">全仓+逐仓</span>
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-tooltip content="修改">
            <el-button
              type="primary"
              size="small"
              circle
              icon="el-icon-edit"
              @click="edit(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="撤单" v-show="!scope.row.open">
            <el-button
              type="danger"
              size="small"
              circle
              icon="el-icon-thumb"
              @click="clearOrder(scope.row.pair)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="user-withdrawal-records-wrap">
      <el-dialog
        :visible.sync="showUserDialog"
        title="账户余额信息"
        width="1200px"
      >
        <withdraw-records
          v-if="showUserDialog"
          :uid="nowUserId"
        ></withdraw-records>
      </el-dialog>
    </div>
    <detail @refresh="handleCurrentChange()"></detail>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Detail from '../detail';

export default {
  name: 'lever',
  data() {
    return {
      showUserDialog: false
    };
  },
  computed: {
    ...mapState('lever', ['projects'])
  },
  components: {
    Detail
  },
  methods: {
    ...mapMutations('lever', ['setEditingProject']),
    ...mapActions('lever', ['removeOrder']),
    edit(project) {
      this.setEditingProject(project);
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    getUserDetail(uid) {
      this.nowUserId = uid;
      this.showUserDialog = true;
    },
    clearOrder(pair) {
      this.$confirm('确定要对该交易对撤单吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.removeOrder({ pair: pair, isLever: true }).then(() => {
          this.$message.success('操作成功！');
          this.list();
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.link-button {
  margin-left: 10px;
}
</style>
